import styled from 'styled-components';

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0px;
    width: 100%;
`;
